import { useEffect } from 'react';
/**
 * Gives `meta[name=viewport]` a content value that makes the viewport non-zoomable
 * on mount. Reverts to the previous value on unmount.
 */
export function useNonScalableViewport() {
    useEffect(() => {
        let meta = document.querySelector('meta[name="viewport"]');
        const newContent = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no';
        if (meta) {
            const previousContent = meta.content;
            meta.content = newContent;
            return () => {
                if (meta) {
                    meta.content = previousContent;
                }
            };
        }
        meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = newContent;
        document.head.appendChild(meta);
        return () => {
            document.head.removeChild(meta);
        };
    }, []);
}
